// src/App.tsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/GlobalStyle';
import { theme } from './styles/theme';
import { LanguageProvider } from './contexts/LanguageContext';
import PortfolioPage from './pages/PortfolioPage';
import ToolsLayout from './tools/ToolsLayout';
import ToolsIndex from './tools/ToolsIndex';
import ToolPage from './tools/ToolPage';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PortfolioPage />} />
            <Route path="/tools" element={<ToolsLayout />}>
              <Route index element={<ToolsIndex />} />
              <Route path=":slug" element={<ToolPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </LanguageProvider>
  );
};

export default App;
